module.exports = __webpack_public_path__ + "static/media/rtf-icon.4da6291a.svg";